import { IsBoolean, IsEnum, IsNumber, IsObject, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export enum FontSizeType {
	px = 'px',
	cqh = 'cqh',
	cqw = 'cqw'
}

export class LineWidthConfigDto {
	@IsBoolean()
	enabled: boolean;

	@IsNumber()
	@IsOptional()
	minFontSize?: number;

	@IsNumber()
	@IsOptional()
	maxFontSize?: number;

	@IsNumber()
	@IsOptional()
	lineSpacing?: number;

	@IsEnum(FontSizeType)
	@IsOptional()
	fontSizeUnit?: FontSizeType;
}

export class LayerAutosizeDto {
	@IsString()
	@IsOptional()
	maxWidth?: string | number;

	@IsString()
	@IsOptional()
	maxHeight?: string | number;

	@IsBoolean()
	@IsOptional()
	multiLine?: boolean;

	@IsBoolean()
	@IsOptional()
	wrap?: boolean;

	@IsString()
	@IsOptional()
	minFontSize?: string;

	@IsString()
	@IsOptional()
	maxFontSize?: string;
}

export class LayerTextDto {
	@IsOptional()
	@IsString()
	content: string;

	@IsOptional()
	@IsBoolean()
	smart?: boolean;

	@IsOptional()
	@IsBoolean()
	isHtml?: boolean; // Indicates if the content contains HTML markup

	@IsObject()
	@IsOptional()
	@ValidateNested()
	@Type(() => LayerAutosizeDto)
	autoSize?: LayerAutosizeDto;

	@IsString()
	@IsOptional()
	minFontSize?: string;

	@IsString()
	@IsOptional()
	maxFontSize?: string;

	@IsString()
	@IsOptional()
	maxLines?: string;

	@IsObject()
	@IsOptional()
	@ValidateNested()
	@Type(() => LineWidthConfigDto)
	fixedWidthLines?: LineWidthConfigDto;

	@IsObject()
	@IsOptional()
	@ValidateNested()
	@Type(() => LineWidthConfigDto)
	uniformFontSize?: LineWidthConfigDto;

	@IsEnum(FontSizeType)
	@IsOptional()
	fontSizeUnit?: FontSizeType;
}
